export default __webpack_public_path__ + "static/media/IMG-20240708-WA0024.6e21f644.jpg";